import { FormField } from "../../helpers/types";
export const getDataFromRecord = (record?: any) => {
   let initData = new Map<string, any>();
   if (record) {
      record?.checklists.forEach((c: any) => {
         if (c.attachments.length) {
            initData = new Map<string, any>([
               ...initData,
               [`item-${c.itemId}`, c.optionValue],
               [`item-${c.itemId}-image`, c.attachments.map((a: any) => a.filename)],
               [`item-${c.itemId}-reason`, c.remarks],
            ]);
         } else {
            initData = new Map<string, any>([
               ...initData,
               [`item-${c.itemId}`, c.optionValue],
               [`item-${c.itemId}-reason`, c.remarks],
            ]);
         }
      });

      ["customer", "driver", "site", "transporter"].forEach((k: string) => {
         let val = record[k];
         if (val) initData.set(`${k}Id`, val.id);

      });
      ["vehicleReg", "vehicleType", "remarks", "licenseNo"].forEach((k: string) => {
         let val = record[k];
         if (val) initData.set(k, val);
      });
   }

   return initData
}
export const RecordFieldsConfig = (updateFormData: any, formData: any, readOnly?: boolean, reInspect?: boolean) => {
   const introFields: FormField[] = [
      {
         name: `vehicleReg`,
         label: "Vehicle Registration Number",
         onChange: updateFormData,
         formData: formData,
         options: {
            required: true,
         },
         readOnly: true,
      },
      {
         name: `vehicleType`,
         label: "Vehicle Type",
         onChange: updateFormData,
         formData: formData,
         options: {
            required: true,
         },
         readOnly: readOnly || reInspect,
      },

      {
         name: `siteId`,
         label: "Site",
         type: "select_setups",
         onChange: updateFormData,
         formData: formData,
         options: {
            required: true,
            setup: "sites",
         },
         setupKind: "sites",
         readOnly,
      },
      // {
      //    name: `driverId`,
      //    label: "Driver",
      //    type: "select_setups",
      //    onChange: updateFormData,
      //    formData: formData,
      //    options: {
      //       required: true,
      //       setup: "drivers",
      //    },
      //    setupKind: "drivers",
      //    readOnly,
      // },
      {
         name: `licenseNo`,
         label: "Driver's license No.",
         type: "number",
         onChange: updateFormData,
         formData: formData,
         readOnly,
      },
      {
         name: `transporterId`,
         label: "Transporter",
         type: "select_setups",
         onChange: updateFormData,
         formData: formData,
         options: {
            isRequired: (formData: Map<string, any>) => {
               if (formData.get("customerId")) {
                  return false;
               }
               return true;
            },
            setup: "transporters",
         },
         cols: 2,
         setupKind: "transporters",
         readOnly: readOnly || reInspect,
      },
      {
         name: `customerId`,
         label: "Customer",
         type: "select_setups",
         onChange: updateFormData,
         formData: formData,
         options: {
            isRequired: (formData: Map<string, any>) => {
               let found = formData.has("transporterId");
               let req = !found;
               return req
            },
            setup: "customers",
         },
         cols: 2,
         setupKind: "customers",
         readOnly: readOnly || reInspect,
      },

   ];

   const finalFields = [
      {
         name: `remarks`,
         label: "Final Remarks",
         type: "textarea",
         cols: 2,
         onChange: updateFormData,
         formData: formData,
         options: {
            required: true,
         },
         readOnly,
      },
   ];

   return {
      introFields,
      finalFields,
   };
};
